// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--1o1-6"};